/* eslint-disable */

import React from "react";
import { renderReact } from "../src/lib/ssrHydrator";
import ArticleSearchContainer from "../src/ArticleSearchForm/containers/ArticleSearchContainer";
import FormItemsConteiner from "../src/ArticleSearchForm/containers/FormItemsContainer";
import PortalPCSearchSidebar from "../src/ArticleSearchForm/components/companies/pc/PortalPCSearchSidebar";
import PortalPCResultHeader from "../src/ArticleSearchForm/components/companies/pc/PortalPCResultHeader";
import PortalRecommendedTopics from "../src/ArticleSearchForm/components/companies/sp/PortalRecommendedTopics";
import PortalPCArticleList from "../src/ArticleSearchForm/components/companies/pc/PortalPCArticleList";
import PortalPCPager from "../src/ArticleSearchForm/components/companies/pc/PortalPCPager";
import PortalPCDetailSearch from "../src/ArticleSearchForm/components/companies/pc/PortalPCDetailSearch";
import Loader from "../src/ArticleSearchForm/components/shared/common/Loader";
import ErrorBoundary from "../src/ErrorBoundary/error_notifier";

function PortalPCArticleSearchForm(props) {
  return (
    <ErrorBoundary>
      <ArticleSearchContainer.Provider
        initialState={{ ...props, requestFromSp: false }}
      >
        <FormItemsConteiner.Provider initialState={{ items: props.items }}>
          <div className="portalPcSearchLayout">
            <PortalPCSearchSidebar />
            <div className="portalPcSearchMain">
              <PortalPCResultHeader />
              <PortalRecommendedTopics topics={props.topics} />
              <PortalPCArticleList
                company_name={props.company_name}
                company_name_ja={props.company_name_ja}
              />
              <PortalPCPager />
            </div>
          </div>
          <PortalPCDetailSearch />
          <Loader />
        </FormItemsConteiner.Provider>
      </ArticleSearchContainer.Provider>
    </ErrorBoundary>
  );
}

export default renderReact(
  "PortalPCArticleSearchForm",
  PortalPCArticleSearchForm
);
